var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H24.75V13.5H4.5V0ZM14.625 3.375C15.5201 3.375 16.3786 3.73058 17.0115 4.36351C17.6444 4.99645 18 5.85489 18 6.75C18 7.64511 17.6444 8.50355 17.0115 9.13649C16.3786 9.76942 15.5201 10.125 14.625 10.125C13.7299 10.125 12.8714 9.76942 12.2385 9.13649C11.6056 8.50355 11.25 7.64511 11.25 6.75C11.25 5.85489 11.6056 4.99645 12.2385 4.36351C12.8714 3.73058 13.7299 3.375 14.625 3.375ZM9 2.25C9 2.84674 8.76295 3.41903 8.34099 3.84099C7.91903 4.26295 7.34674 4.5 6.75 4.5V9C7.34674 9 7.91903 9.23705 8.34099 9.65901C8.76295 10.081 9 10.6533 9 11.25H20.25C20.25 10.6533 20.4871 10.081 20.909 9.65901C21.331 9.23705 21.9033 9 22.5 9V4.5C21.9033 4.5 21.331 4.26295 20.909 3.84099C20.4871 3.41903 20.25 2.84674 20.25 2.25H9ZM0 4.5H2.25V15.75H20.25V18H0V4.5Z",
    fill: "#01E69C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.51cecaeb954ae3ab6d228107dc15f245.svg";
export { ForwardRef as ReactComponent };